"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Title1: function() {
        return _Title1.Title1;
    },
    title1ClassNames: function() {
        return _useTitle1Stylesstyles.title1ClassNames;
    }
});
const _Title1 = require("./Title1");
const _useTitle1Stylesstyles = require("./useTitle1Styles.styles");
